import React, { useEffect, useState } from 'react';

import { Dialog, DialogContent } from '@column/ui';

import { NotificationList } from '~/components';
import { SetupDeviceMFA } from '~/lib/authn';
import { useNotificationStore } from '~/stores/Notification';

import { DialogHeaderWithClose } from './_components/DialogHeaderWithClose';

interface Props {
  onClose: () => void;
  onSuccess: () => void;
  open: boolean;
}

export const SetupMfaTotpModal: React.FC<Props> = ({ onClose, onSuccess, open }) => {
  const clearNotifications = useNotificationStore((s) => s.clearNotifications);

  // Once the code verifies, `SetupDeviceMFA` draws an animated check inline over the
  // code input (rather than swapping the whole modal for a success screen). We hold that
  // confirmation for a beat, then hand back to `onSuccess` so the modal animates away.
  const [succeeded, setSucceeded] = useState<boolean>(false);

  useEffect(() => {
    if (open) {
      setSucceeded(false);
      clearNotifications('popup');
    }
  }, [open, clearNotifications]);

  useEffect(() => {
    if (!succeeded) {
      return undefined;
    }
    const timer = setTimeout(onSuccess, 1200);
    return () => clearTimeout(timer);
  }, [succeeded, onSuccess]);

  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent
        overlayScroll
        showCloseButton={false}
        className="gap-3 sm:max-w-xl"
        onOpenAutoFocus={(event) => {
          event.preventDefault();
        }}
      >
        <DialogHeaderWithClose title="Set Up Authenticator App" />

        <NotificationList display="popup" spacing="bottom" className="!m-0" />

        <SetupDeviceMFA
          enabled={open}
          onSetupComplete={() => setSucceeded(true)}
          errorNotificationDisplay="popup"
          successNotificationDisplay="global"
        />
      </DialogContent>
    </Dialog>
  );
};
